import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Button } from "@/components/ui/button";
import { Check, ChevronsUpDown } from "lucide-react";

export const padrLabel = (p) => p ? (p.ragione_sociale || `${p.nome || ""} ${p.cognome || ""}`.trim() || p.codice) : "";
export const AZIENDA = "__azienda";

export const PadroncinoSelect = ({ value, onChange, padroncini, placeholder = "— da assegnare —", className = "h-7 text-xs w-full", testId, allowEmpty = false, aziendaOption = false }) => {
  const [open, setOpen] = useState(false);
  const sel = padroncini.find((p) => p.id === value);
  const isAz = aziendaOption && value === AZIENDA;
  const pick = (id) => { onChange(id); setOpen(false); };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" role="combobox" className={`${className} justify-between font-normal px-2`} data-testid={testId}>
          <span className={`truncate ${sel || isAz ? "" : "text-muted-foreground"}`}>{isAz ? "AZIENDA (uso interno)" : sel ? padrLabel(sel) : placeholder}</span>
          <ChevronsUpDown className="w-3.5 h-3.5 opacity-50 shrink-0" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-72" align="start">
        <Command>
          <CommandInput placeholder="Cerca codice o nome..." data-testid={testId ? `${testId}-search` : undefined} />
          <CommandList>
            <CommandEmpty>Nessun padroncino trovato</CommandEmpty>
            {allowEmpty && <CommandItem value="__nessuno" onSelect={() => pick("")}>— nessuno —</CommandItem>}
            {aziendaOption && <CommandItem value="azienda uso interno aziendale" onSelect={() => pick(AZIENDA)} data-testid={testId ? `${testId}-opt-azienda` : undefined}>
              <Check className={`w-3.5 h-3.5 ${isAz ? "opacity-100" : "opacity-0"}`} />
              <span className="font-semibold">AZIENDA (uso interno)</span>
            </CommandItem>}
            {padroncini.map((p) => (
              <CommandItem key={p.id} value={`${p.codice} ${padrLabel(p)} ${p.id}`} onSelect={() => pick(p.id)}
                           data-testid={testId ? `${testId}-opt-${p.id}` : undefined}>
                <Check className={`w-3.5 h-3.5 ${value === p.id ? "opacity-100" : "opacity-0"}`} />
                <span className="font-mono text-xs w-14 shrink-0">{p.codice}</span>
                <span className="truncate">{padrLabel(p)}</span>
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
